import { render } from "./OptionalField.vue?vue&type=template&id=435b3865&scoped=true"
import script from "./OptionalField.vue?vue&type=script&lang=js"
export * from "./OptionalField.vue?vue&type=script&lang=js"

import "./OptionalField.vue?vue&type=style&index=0&id=435b3865&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435b3865"]])

export default __exports__